import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCompassFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="M8 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm3.63 3.685a.659.659 0 0 0-.815-.815L6.507 5.6a1.32 1.32 0 0 0-.906.907l-1.23 4.308a.659.659 0 0 0 .814.815l4.308-1.23a1.32 1.32 0 0 0 .906-.907l1.23-4.308Z"
      />
      <circle cx="8" cy="8" r="1" fill="currentColor" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCompassFilled);
export default ForwardRef;
